import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from './../../APP/COMPONENTS/Loader';

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

/*
https://developer.mozilla.org/en-US/docs/Web/API/WebUSB_API
*/

class Production extends Component {
    constructor(props) {
        super(props);
        this.state = {
            USER: this.props.USER,
            PRODUCTS: false,
            DEVICE: false
        }
    }

    componentDidMount = () => {
        navigator.usb.addEventListener("connect", async (event) => {
            console.log(event)
            await event.device.open();
            await event.device.selectConfiguration(1);
            await event.device.claimInterface(1);
        });
    }


    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.USER !== prevProps.USER) {
            this.setState({ USER: this.props.USER });
        }
    }

    findUsbDevices = async () => {
        let device;

        try {
            if ("usb" in navigator) {
                navigator.usb.requestDevice({ filters: [{ vendorId: 0x0483 }] })
                    .then(async device => {
                        this.setState({ DEVICE: device })

                        const interfaceId = 1;

                        await device.open();
                        await device.selectConfiguration(1);
                        await device.claimInterface(interfaceId);

                        while (true) {
                            const buffer = Buffer.concat([
                                Buffer.from('GET\\r\\n')])
                            let result = await device.controlTransferIn(1, 0)

                            console.log(result)
                            console.log(buffer)

                            if (result.data && result.data.byteLength === 6) {
                                console.log('Channel 1: ' + result.data.getUint16(0));
                                console.log('Channel 2: ' + result.data.getUint16(2));
                                console.log('Channel 5: ' + result.data.getUint16(4));
                            }

                            if (result.status === 'stall') {
                                console.warn('Endpoint stalled. Clearing.');
                                await device.clearHalt(1);
                            }
                        }
                    })
            } else {
                alert('Браузер не поддерживает работу с WEBApi')
            }
        } catch (error) {
            alert('Error: ' + error.message);
        }
    }

    render() {
        if (!this.state.USER) {
            return <Redirect to="/" />
        }

        return (
            <div className="main_content">
                <Helmet>
                    <title>Производство</title>
                </Helmet>
                <a onClick={ () => this.findUsbDevices() }>Подключить весы</a>
            </div>
        );
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(Production))
